import React from 'react';
import type { DropdownNavigationButton } from '../../../types';
import styles from './CrawlerDropdown.module.scss';

interface CrawlerDropdownProps {
  item: DropdownNavigationButton;
}

export const CrawlerDropdown = ({ item }: CrawlerDropdownProps) => {
  return (
    <div className={styles.crawlerDropdownContainer}>
      <span className={styles.crawlerDropdownTrigger}>
        {item.label}
      </span>
      <div className={styles.crawlerDropdownBox}>
        <ul className={styles.crawlerDropdownList}>
          {item.items?.map(subItem => {
            // Handle divider items
            if (subItem.type === 'divider') {
              return <li key={subItem.id} className={styles.crawlerDivider}></li>;
            }

            // Handle expandable items with nested children
            if (subItem.type === 'expandable' && subItem.items) {
              return (
                <React.Fragment key={subItem.id}>
                  <li className={styles.crawlerDropdownItem}>
                    <div className={styles.crawlerExpandableHeader}>
                      {subItem.label}
                    </div>
                    <ul className={styles.crawlerExpandableList}>
                      {subItem.items.map(nestedItem => (
                        <li key={nestedItem.id}>
                          <a
                            href={nestedItem.href || '#'}
                            target={nestedItem.external ? '_blank' : undefined}
                            rel={nestedItem.external ? 'noopener noreferrer' : undefined}
                            className={styles.crawlerExpandableLink}
                          >
                            {nestedItem.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </li>
                </React.Fragment>
              );
            }

            // Handle regular link items
            return (
              <li key={subItem.id} className={styles.crawlerDropdownItem}>
                <a
                  href={subItem.href || '#'}
                  target={subItem.external ? '_blank' : undefined}
                  rel={subItem.external ? 'noopener noreferrer' : undefined}
                  className={styles.crawlerDropdownLink}
                >
                  {subItem.label}
                  {subItem.secondaryLabel && (
                    <span className={styles.crawlerSecondaryLabel}>
                      {subItem.secondaryLabel}
                    </span>
                  )}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}; 